(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/hooks/use-fetch-draws.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/hooks/use-fetch-draws.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const useFetchDraws = product => {
  const [isFirstPlayableDraws, setIsFirstPlayableDraws] = useState(false);
  useEffect(() => {
    const prefetchDraws = async () => {
      const firstPlayableDraws = await svs.numbergames.draws.asyncDrawsApi.firstPlayableDraw(svs.numbergames.productMapping.getProductId(product));
      setIsFirstPlayableDraws(firstPlayableDraws);
    };
    prefetchDraws();
  }, [product]);
  return {
    isFirstPlayableDraws
  };
};
setGlobal('svs.numbergames.prolong_game.hooks.useFetchDraws', useFetchDraws);

 })(window);